<div
    [id]="form.displayId()"
    class="button-group widget-specific-nav-align"
    [class.button-zero-variant]="isZero"
    [style.--btn-group-z-index]="groupZIndex()"
    [style.--btn-group-z-index-mobile]="groupZIndexMobile()"
    [style.--btn-group-transform]="groupTransform()"
    [style.--btn-group-transform-mobile]="groupTransformMobile()"
    [style.--btn-group-margin]="groupMargin()"
    [style.--btn-item-margin]="itemMargin()"
    [style.--btn-group-justify]="groupJustify()"
    [style.--btn-group-justify-mobile]="groupJustifyMobile()"
    [style.--btn-group-justify-tablet]="groupJustifyTablet()"
>
    @for (button of form.buttons().value(); track $index; let i = $index) {
        <a
            class="sp-button-item"
            [id]="button.elementId"
            [class]="getButtonClass(button)"
            [style]="buttonsCssVars()[i]"
        >
            @if (button.buttonIcon?.isActive) {
                <span class="icon" [innerHTML]="getIcon(button.buttonIcon?.icon)"></span>
            }
            {{ button.label }}
        </a>
    }
</div>
